import * as React from 'react'
import { withRouter } from 'react-router'
import qs from 'qs'
import _, { startCase } from 'lodash'

//components
import CatalogLayout from '../../../../components/ui/CatalogLayout/CatalogLayout'
import Icon from '../../../../components/ui/Icon/Icon'
import SearchModal from '../../../../components/home/SearchModal/SearchModal'
import SearchMallModal from '../../../../components/home/SearchMallModal/SearchMallModal'
import StoreModal from '../../../../components/home/StoreModal/StoreModal'
import * as ExploreApiService from '../../../../services/api/requests/Explore'
import {
  CardContent,
  LogoContainer,
  Logo,
  Title,
  StyledCatalogList,
  ErrorCard,
  StyledLink,
  StyledShopDineCard,
  ZingIconComponent,
  Heading,
  FormContainer,
  SelectMallButton,
  InputContainer,
  Content,
  StyledBanner,
  BannerDescription,
  CategoryContainer,
  CategoryPill,
} from './MainView.style'

// data
import { REWARDS_REWARDS_CATALOG } from '../../../../services/data/errorNames.json'
import { DEFAULT_CATEGORY } from '../../../../services/data/rewardsCategory.json'
import { VOUCHERS } from '../../../../services/data/profilePages.json'

// analytics
import {
  setGAPageView,
  setGAEvent,
  setGACustomEvent,
} from '../../../../services/analytics/google-analytics'

// controllers
import { doGetAllMalls } from '../../../../controllers/Malls'
import {
  doGetAllRewards,
  doGetAllRewardsMerchants,
  doGetRewardsByMerchant,
  doGetRewardsMerchants,
} from '../../../../controllers/Offers'
import {
  doGetEngangementTypes,
  doGetContentTypeEConcierge,
  doGetExploreShops,
  doGetExploreDine,
  doGetExploreUnwind,
  doGetMallMerchants,
} from '../../../../controllers/Explore'

const ENGAGEMENT_TYPE = doGetEngangementTypes()
const ECONCIERGE = doGetContentTypeEConcierge()

class MainView extends React.Component {
  /* debouncedSearch = _.debounce(search => {
    setGAEvent('rewards_merchant', 'search_merchant_rewards', search)
  }, 250) */

  constructor(props) {
    super(props)

    const { location } = props.history

    const initialSearch = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    })

    this.state = {
      apiKey: '',
      merchants: [],
      shopMerchants: [],
      dineMerchants: [],
      unwindMerchants: [],
      searchQuery: initialSearch.q || '',
      searched: [],
      selectedCatalog: {
        id: DEFAULT_CATEGORY,
      },
      modalToggle: false,
      modalTitle: '',
      searchMallModalState: false,
      searchModalState: false,
      malls: [],
      mallList: [],
      prevSelectedMall: null,
      openSelectMall: false,
      showMerchantModal: false,
      merchantModalData: [],
      mallMerchatData: [],
      selectedCategory: 'all',
    }

    this.getRewardsMerchants(DEFAULT_CATEGORY)
    this.getShopMerchants()
    this.getDineMerchants()
    this.getUnwindMerchants()
    this.getMallMerchants(null, this.state.selectedCategory)

    doGetAllMalls({
      onSuccess: ({ data }) => {
        this.setState({
          malls: data,
          mallList: data.map(mall => ({
            name: mall.name,
            value: mall.slugName,
          })),
        })
      },
    })
  }

  componentWillMount() {
    this.retrieveInitialData()
  }

  componentDidMount() {
    const { location } = this.props
    setGAPageView(location.pathname)
  }

  componentDidUpdate(prevProps) {
    const { match, location } = this.props
    const { viewType, viewId } = match.params
    const {
      viewType: prevViewType,
      viewId: prevViewId,
    } = prevProps.match.params

    if (viewType !== prevViewType || viewId !== prevViewId) {
      this.displayModal()
    }

    if (location.pathname !== prevProps.location.pathname) {
      setGAPageView(location.pathname)
    }
  }

  getShopMerchants = (mallSlugName = null) => {
    const { selectedMallSlug, accessToken } = this.props
    doGetExploreShops({
      accessToken,
      collectionType: ECONCIERGE,
      onSuccess: ({ data }) => {
        this.setState({ shopMerchants: data })
      },
    })('', mallSlugName ? mallSlugName : selectedMallSlug)
  }

  getDineMerchants = (mallSlugName = null) => {
    const { selectedMallSlug, accessToken } = this.props
    doGetExploreDine({
      accessToken,
      collectionType: ECONCIERGE,
      onSuccess: ({ data }) => {
        this.setState({ dineMerchants: data })
      },
    })('', mallSlugName ? mallSlugName : selectedMallSlug)
  }

  getUnwindMerchants = (mallSlugName = null) => {
    const { selectedMallSlug, accessToken } = this.props
    doGetExploreUnwind({
      accessToken,
      collectionType: ECONCIERGE,
      onSuccess: ({ data }) => {
        this.setState({ unwindMerchants: data })
      },
    })('', mallSlugName ? mallSlugName : selectedMallSlug)
  }

  getMallMerchants = (mallSlug, category) => {
    const { selectedMallSlug } = this.props
    doGetMallMerchants({
      mallSlugName: selectedMallSlug,
      category,
      onSuccess: ({ data }) => {
        this.setState({ mallMerchatData: data })
      },
    })(mallSlug ? mallSlug : selectedMallSlug)
  }

  getRewardsMerchants = async (id = 0) => {
    const {
      accessToken,
      history,
      errorList,
      setError,
      removeError,
    } = this.props

    if (errorList.length) {
      removeError(REWARDS_REWARDS_CATALOG)
    }

    const search = qs.parse(history.location.search, {
      ignoreQueryPrefix: true,
    })

    const pageLoadStart = Date.now()

    if (id === 0) {
      await doGetAllRewardsMerchants({
        accessToken,
        onSuccess: ({ data }) => {
          this.setState({
            merchants: data.sort((a, b) =>
              a.name > b.name ? 1 : a.name < b.name ? -1 : 0,
            ),
            searched: search.q
              ? data.filter(merchant =>
                  merchant.name.toLowerCase().includes(search.q.toLowerCase()),
                )
              : [],
          })
          setGAEvent(
            'page',
            'loading_duration',
            'rewards_catalog',
            Date.now() - pageLoadStart,
          )
        },
        onError: error => {
          setError({
            name: REWARDS_REWARDS_CATALOG,
            error: error.message,
          })
        },
      })
    } else {
      doGetRewardsMerchants({
        accessToken,
        onSuccess: ({ data }) => {
          this.setState({
            merchants: data.sort((a, b) =>
              a.name > b.name ? 1 : a.name < b.name ? -1 : 0,
            ),
            searched: search.q
              ? data.filter(merchant =>
                  merchant.name.toLowerCase().includes(search.q.toLowerCase()),
                )
              : [],
          })
          setGAEvent(
            'page',
            'loading_duration',
            'rewards_catalog',
            Date.now() - pageLoadStart,
          )
        },
        onError: error => {
          setError({
            name: REWARDS_REWARDS_CATALOG,
            error: error.message,
          })
        },
      })('', id)
    }
  }

  onCategoriesChange = e => {
    const catalogId = e.target.value
    const { setRewards, accessToken } = this.props

    doGetAllRewards({ accessToken, setRewards })('', catalogId)
  }

  retrieveInitialData = async () => {
    const { waitRenderServer, renderServer } = this.props

    waitRenderServer(true)

    await this.displayModal()

    renderServer()
  }

  displayModal = async () => {
    const {
      match,
      setRewardModalData,
      setRewardModalStatus,
      accessToken,
      // advanceAccount,
    } = this.props
    const { viewId } = match.params

    if (viewId) {
      setRewardModalStatus(1)
      try {
        await doGetRewardsByMerchant({ accessToken, setRewardModalData })(
          viewId,
        )
        setRewardModalStatus(0)
      } catch (e) {
        setRewardModalStatus(4)
      }
    } else {
      setRewardModalData({})
      setRewardModalStatus(null)

      setGAEvent('page', 'page_visit', 'rewards_catalog')
    }
  }

  handleClose = () => {
    const {
      push,
      baseUrl,
      setRewardModalData,
      setRewardModalStatus,
    } = this.props

    if (push) {
      push(`${baseUrl}`)
      setRewardModalData({})
      setRewardModalStatus(null)
    }
  }

  onCatalogChange = catalog => {
    this.setState({
      merchants: [],
    })
    this.getRewardsMerchants(catalog.id)

    setGAEvent('rewards', 'rewards_category', catalog.name)
  }

  onCatalogSearch = e => {
    const { merchants } = this.state

    const searched = merchants.filter(merchant => {
      const merchantName = merchant.name.toLowerCase()
      const searchQuery = e.target.value.toLowerCase()

      return merchantName.includes(searchQuery)
    })

    this.setState({
      searchQuery: e.target.value,
      searched,
    })

    this.debouncedSearch(e.target.value)
  }

  displayMyVouchers = data => {
    const {
      displayProfileModal,
      setProfileModalPage,
      setProfileModalDetailPage,
      accessToken,
    } = this.props

    if (accessToken) {
      displayProfileModal(true)
      setProfileModalPage(VOUCHERS)
      if (data) {
        setProfileModalDetailPage(data)
      }
    }
  }

  handleModal = (state, title = '') => {
    this.setState({
      modalToggle: state,
      modalTitle: title,
    })
  }

  handleShowExploreSearch = e => {
    e.stopPropagation()
    this.setState({
      searchModalState: true,
    })
  }

  searchMallModalToggle = e => {
    this.setState({
      searchMallModalState: false,
    })
  }

  searchModalToggle = e => {
    this.setState({
      searchModalState: false,
    })
  }

  handleSelectMall = e => {
    e.stopPropagation()
    this.setState({
      searchMallModalState: true,
    })
  }

  handleMerchantModal = itemId => {
    ExploreApiService.getStore(itemId).then(response => {
      this.setState({
        showMerchantModal: true,
        merchantModalData: response.data,
      })
    })
  }

  handleMerchantModalClose = e => {
    this.setState({ showMerchantModal: false })
  }

  onChangeMall = async mallSlugName => {
    const {
      push,
      // malls,
      // baseUrl,
      // accessToken,
      // showAddFavorite,
      // disableFavoritePrompt,
      // favoriteMalls,
      setSelectedMallSlug,
      // match,
    } = this.props

    // const { viewType, viewId } = match.params

    if (push) {
      this.setState({
        searchMallModalState: false,
        selectedCategory: 'all',
      })

      setGACustomEvent('mall_directory', {
        mall_directory_dropdown_mall: mallSlugName,
      })
      setSelectedMallSlug(mallSlugName)
      this.getMallMerchants(mallSlugName)
      // this.getShopMerchants(mallSlugName)
      // this.getDineMerchants(mallSlugName)
      // this.getUnwindMerchants(mallSlugName)
    }
  }

  handleSelectedCategory = item => {
    this.setState({ selectedCategory: item }, () => {
      this.getMallMerchants(null, item)
    })

    setGACustomEvent('mall_directory', { mall_directory_button_category: item })
  }

  render() {
    const {
      history,
      showRewardModal,
      rewardModalData,
      rewardModalStatus,
      advanceAccount,
      accessToken,
      push,
      baseUrl,
      setLoyaltyPoints,
      loyaltyPoints,
      setLoyaltyPointsError,
      loyaltyPointsError,
      errorList,
      selectedMallSlug,
      setFavoriteMalls,
      match,
      deviceLocation,
      favoriteMalls,
      setSelectedMallSlug,
      merchantModalStatus,
      // malls,
      selectedCategory,
      ...theProps
    } = this.props

    const {
      // merchants,
      shopMerchants,
      dineMerchants,
      unwindMerchants,
      // searched,
      // searchQuery: searchQueryState,
      // selectedCatalog,
      modalToggle,
      showMerchantModal,
      merchantModalData,
      mallMerchatData,
    } = this.state

    const selectedMall = this.state.malls.find(
      mall =>
        mall.slugName === selectedMallSlug && mall.explore && mall.slugName,
    )

    const categoriesList = [
      'all',
      'shop',
      'dine',
      'entertainment',
      'essentials',
      'services',
    ]

    return (
      <CatalogLayout
        banner={StyledBanner}
        match={match}
        selectedMall={selectedMall}
        accessToken={accessToken}
        isMallDirectory={true}
        {...theProps}
      >
        <Heading>
          <BannerDescription>You are currently at:</BannerDescription>
          <FormContainer>
            <SelectMallButton
              onClick={e => {
                this.handleSelectMall(e)
              }}
            >
              <span>
                {(selectedMall && selectedMall.name) || 'Select Mall'}
              </span>
              <Icon name="caret" />
            </SelectMallButton>
            <InputContainer onClick={this.handleShowExploreSearch}>
              Search
              <Icon name="search" />
            </InputContainer>
          </FormContainer>
        </Heading>

        <Content>
          <CategoryContainer>
            {categoriesList.map(item => {
              return (
                <CategoryPill
                  isActive={this.state.selectedCategory === item}
                  onClick={() => this.handleSelectedCategory(item)}
                >
                  {startCase(item)}
                </CategoryPill>
              )
            })}
          </CategoryContainer>
          {mallMerchatData && mallMerchatData.length > 0 && (
            <>
              <StyledCatalogList
                dataSource={mallMerchatData}
                loadingComponent={() => (
                  <ErrorCard>
                    <ZingIconComponent />
                  </ErrorCard>
                )}
                renderItem={(item, index) => (
                  <StyledLink
                    // to={`${viewTypeBaseUrl(item.type, selectedMallSlug)}/${
                    //   item.itemId
                    // }`}
                    onClick={() => {
                      this.handleMerchantModal(item.id)

                      setGACustomEvent('mall directory', {
                        mall_directory_store_selection: item.merchantName,
                      })
                    }}
                  >
                    <StyledShopDineCard cardImageUrl={item.bannerUrl}>
                      <CardContent>
                        <LogoContainer cardImageUrl={item.bannerUrl}>
                          {item.logoUrl ? (
                            <Logo src={item.logoUrl} />
                          ) : (
                            <ZingIconComponent />
                          )}
                        </LogoContainer>
                        <Title>{item.merchantName}</Title>
                      </CardContent>
                    </StyledShopDineCard>
                  </StyledLink>
                )}
              />
            </>
          )}
        </Content>

        <SearchMallModal
          modalState={this.state.searchMallModalState}
          onClose={this.searchMallModalToggle}
          malls={this.state.malls}
          push={push}
          match={match}
          accessToken={accessToken}
          setFavoriteMalls={setFavoriteMalls}
          baseUrl={baseUrl}
          currentMall={selectedMallSlug}
          onChangeMall={this.onChangeMall}
          selectedMall={selectedMall && selectedMall.id}
          deviceLocation={deviceLocation}
          displayClose={selectedMallSlug !== ''}
          favoriteMalls={favoriteMalls}
          setSelectedMallSlug={setSelectedMallSlug}
        />

        {this.state.searchModalState && (
          <SearchModal
            altTitle={'Explore'}
            onCloseSelectMall={this.handleCloseSelectMall}
            onClose={this.searchModalToggle}
            onCloseMerchant={this.handleMerchantModalClose}
            onSelectMerchant={this.handleMerchantModal}
            initialMall={selectedMall}
            malls={this.state.malls}
            mallList={this.state.mallList}
            push={push}
            match={match}
            contentType={0}
            accessToken={accessToken}
            favoriteMalls={favoriteMalls}
            deviceLocation={deviceLocation}
            setFavoriteMalls={setFavoriteMalls}
            isEconcierge={false}
            isExplore={true}
          />
        )}

        <StoreModal
          malls={this.state.malls}
          show={showMerchantModal}
          data={merchantModalData}
          loading={merchantModalStatus}
          onClose={this.handleMerchantModalClose}
        />
      </CatalogLayout>
    )
  }
}

MainView.defaultProps = {
  // TODO: specify default props
}

MainView.propTypes = {
  // TODO: specify prop types
}

export default withRouter(MainView)
